export default __webpack_public_path__ + "static/media/assets-icon.ed54d91e.svg";